// GAVION stripe-sync: Settings › Integrations › Stripe (admins).
export const stripeEn = {
  title: "Stripe",
  description:
    "Read only: subscriptions, MRR and paid or unpaid months come from Stripe. The CRM never writes to Stripe.",
  loading: "Checking the key…",
  key: {
    absent: "Stripe key missing",
    not_restricted: "Key refused: use a read-only restricted key (rk_…)",
    ok: "Read-only restricted key: OK",
  },
  webhook_secret_set: "Webhook secret: set",
  webhook_secret_missing: "Webhook secret: missing",
  last_webhook: "Last webhook: %{at}",
  no_webhook: "No webhook received",
  last_sync:
    "Last sync: %{at} — %{created} created, %{linked} linked, %{changed} changed, %{unchanged} unchanged",
  last_sync_failed: "Last sync: %{at} — failed (%{code})",
  never_synced: "Never synced",
  sync_now: "Sync now",
  synced_toast: "Stripe sync finished.",
  replayed_toast: "Waiting items retried.",
  matched_toast: "Stripe customer matched.",
  mapped_toast: "Price mapped.",
  interval: { month: "per month", year: "per year" },
  review: {
    title: "To match (%{n})",
    list: "To match",
    empty: "Nothing to match.",
    choose_company: "Choose the company",
    company_label: "Company for %{name}",
    match: "Match",
    price_label: "Package or add-on",
    choose: "Choose…",
    packages: "Packages",
    addons: "Add-ons",
    map: "Map the price",
    replay: "Retry",
  },
  reasons: {
    no_match: "No company found",
    ambiguous: "Several possible companies",
    unmapped_price: "Price not mapped to a package or an add-on",
    currency: "Currency other than CAD",
    interval: "Billing interval not supported (monthly or yearly only)",
    items: "Items not recognized (one package per subscription)",
    other_subscription:
      "The company already has another active Stripe subscription",
    overlaps_cancelled: "Overlaps a cancelled subscription of the company",
    start_mismatch:
      "The Stripe start is later than the first paid month in the CRM: check both dates, then retry",
    tax_inclusive:
      "Tax-inclusive price in Stripe: use a price before tax, then retry",
    unknown: "Error: %{code}",
  },
  errors: {
    stripe_key_absent: "Stripe key missing",
    stripe_key_not_restricted: "Key refused: use a restricted key (rk_…)",
    stripe_unavailable: "Stripe is unreachable. Try again.",
    managed_by_stripe: "This Stripe customer is already matched.",
    invalid_price_map: "Choose a package or an add-on.",
    forbidden: "Admins only.",
    not_found: "Not found. Refresh the page.",
    unknown: "Something went wrong (code: %{code}).",
  },
};
